export const ExpertRoleConstants = {
    PRICESYSTEM_SUBSCRIPTION: 0,
    PRICESYSTEM_LEAD: 1,
    PRICESYSTEM_PACK: 2,
    PRICESYSTEM_PREPAID: 3,
    PRICESYSTEM_STRIPE: 5,
    PRICESYSTEM_MANDAAT_B2C: 9,
    PRICESYSTEM_MANDAAT_B2B: 10,
    LEVEL_DEFAULT: 0,
    LEVEL_PLATINUM: 10,
    LEVEL_ALL: 100

} as const;

export const ExpertRoleSubscriptionLevelConstants = {
    SUBSC_LEVEL_BASIC: 10,
    SUBSC_LEVEL_PRO: 20,
    SUBSC_LEVEL_PRO_PLUS: 30
}